import { render, staticRenderFns } from "./MailLimit.vue?vue&type=template&id=6859c1c8&"
import script from "./MailLimit.vue?vue&type=script&lang=js&"
export * from "./MailLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports